import { useMutation } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useCreatePaypalAgreement = () => {
  const mutation = useMutation({
    mutationFn: paymentRepo.createPaypalAgreement,
  });

  return useMutationMemoized(mutation);
};

export type CreatePaypalAgreementMutation = ReturnType<typeof useCreatePaypalAgreement>;
